(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  let checks = 0;
  const ptppLooxPopup = document.querySelector('[data-ptpp-loox-popup]');
  if (ptppLooxPopup) {
    function checkLOOX() {
      if (!window.LOOX && checks < 3) {
        checks += 1;
        setTimeout(function() {
          checkLOOX();
        },400);
      } else {
        ptppLooxPopup.classList.remove('loading');
      }
    }
    checkLOOX();
    ptppLooxPopup.addEventListener('click', function() {
      window.LOOX.openVisitorLevelReferralModal();
    });
  }
  class OfficialMerch extends HTMLElement {
    constructor() {
      super();      
    }
    connectedCallback() {
      this.querySelector('button').addEventListener('click', this.openOfficialMerchPopup);
    }
    openOfficialMerchPopup() {
      
    }
  }
  customElements.define('official-merch', OfficialMerch);

  class MobileArtistsList extends HTMLElement {
    constructor() {
      super();
      this.artists = [];
      this.fullArtists = [];
      this.currentLetter = null;
      this.currentLetterArtists = [];
      this.mode = 'letter'; // 'letter' or 'search'
      this.currentResults = [];

      // Virtual scroll settings
      this.itemHeight = 42; // Height of each artist item in pixels
      this.bufferSize = 5;  // Extra items to render above/below viewport
      this.visibleItems = [];
      this.scrollRAF = null;

      this.submenu = null;
      this.artistsList = null;
      this.hasViewAllRow = false;
      this.submenuTitle = null;
      this.searchInput = null;
      this.menuDrawerDetails = null;
      this.listResizeObserver = null;

      this.onLetterClick = this.onLetterClick.bind(this);
      this.onBackClick = this.onBackClick.bind(this);
      this.onSearchOpenClick = this.onSearchOpenClick.bind(this);
      this.onSearchInput = this.onSearchInput.bind(this);
      this.onMenuDrawerToggle = this.onMenuDrawerToggle.bind(this);
      this.onVirtualScroll = this.onVirtualScroll.bind(this);
    }

    connectedCallback() {
      const artistsData = this.querySelector('#mobile-top-bar-artists');
      if (artistsData) {
        try {
          this.artists = JSON.parse(artistsData.innerHTML);
        } catch (error) {
          console.error('Error parsing artists data:', error);
        }
      }
      const fullArtistsData = this.querySelector('#mobile-full-artists');
      if (fullArtistsData) {
        try {
          this.fullArtists = JSON.parse(fullArtistsData.innerHTML);
        } catch (error) {
          console.error('Error parsing full artists data:', error);
        }
      }

      // Find the menu drawer container to locate elements outside this component
      const menuDrawer = this.closest('.menu-drawer__inner-container');

      this.submenu = menuDrawer ? menuDrawer.querySelector('[data-artists-submenu]') : null;
      this.artistsList = menuDrawer ? menuDrawer.querySelector('[data-artists-list]') : null;
      this.submenuTitle = menuDrawer ? menuDrawer.querySelector('[data-artists-submenu-title]') : null;
      this.searchInput = menuDrawer ? menuDrawer.querySelector('[data-artists-search-input]') : null;

      const backButton = menuDrawer ? menuDrawer.querySelector('[data-artists-back]') : null;
      const searchOpenButton = this.querySelector('[data-artists-search-open]');
      const letterButtons = this.querySelectorAll('[data-letter]');

      if (backButton) {
        backButton.addEventListener('click', this.onBackClick);
      }

      if (searchOpenButton) {
        searchOpenButton.addEventListener('click', this.onSearchOpenClick);
      }

      if (this.searchInput) {
        this.searchInput.addEventListener('input', this.onSearchInput);
      }

      letterButtons.forEach((button) => {
        button.addEventListener('click', this.onLetterClick);
      });

      // Add scroll listener for virtual scrolling
      if (this.artistsList) {
        this.artistsList.addEventListener('scroll', this.onVirtualScroll, { passive: true });

        // The list is rendered before the submenu finishes opening, so its height can
        // still be 0 at that point. Re-run the windowing whenever it gets a real size.
        if (typeof ResizeObserver !== 'undefined') {
          this.listResizeObserver = new ResizeObserver(() => this.updateVisibleItems());
          this.listResizeObserver.observe(this.artistsList);
        }
      }

      // Listen for menu drawer close to also close artists submenu
      this.menuDrawerDetails = this.closest('details');
      if (this.menuDrawerDetails) {
        this.menuDrawerDetails.addEventListener('toggle', this.onMenuDrawerToggle);
      }
    }

    disconnectedCallback() {
      if (this.listResizeObserver) {
        this.listResizeObserver.disconnect();
        this.listResizeObserver = null;
      }

      // These two live outside the component, so they would otherwise keep a
      // detached instance alive and writing into its stale virtual content.
      if (this.artistsList) {
        this.artistsList.removeEventListener('scroll', this.onVirtualScroll);
      }
      if (this.menuDrawerDetails) {
        this.menuDrawerDetails.removeEventListener('toggle', this.onMenuDrawerToggle);
      }
      if (this.scrollRAF) {
        cancelAnimationFrame(this.scrollRAF);
        this.scrollRAF = null;
      }
    }

    onVirtualScroll() {
      // Use requestAnimationFrame to throttle scroll updates
      if (this.scrollRAF) return;
      this.scrollRAF = requestAnimationFrame(() => {
        this.updateVisibleItems();
        this.scrollRAF = null;
      });
    }

    updateVisibleItems() {
      if (!this.artistsList || !this.virtualContent) return;

      const scrollTop = this.artistsList.scrollTop;
      // Fall back to the window height while the drawer is still animating open,
      // otherwise a clientHeight of 0 would only render `bufferSize` items.
      const viewportHeight = this.artistsList.clientHeight || window.innerHeight;

      // The "view all" link is the last row of the list, so it counts as an item
      const rowCount = this.currentResults.length + (this.hasViewAllRow ? 1 : 0);

      // Calculate which items should be visible
      const startIndex = Math.max(0, Math.floor(scrollTop / this.itemHeight) - this.bufferSize);
      const endIndex = Math.min(
        rowCount,
        Math.ceil((scrollTop + viewportHeight) / this.itemHeight) + this.bufferSize
      );

      // Only re-render if the visible range changed
      if (startIndex === this.lastStartIndex && endIndex === this.lastEndIndex) return;
      this.lastStartIndex = startIndex;
      this.lastEndIndex = endIndex;

      // Update the content
      const fragment = document.createDocumentFragment();

      for (let i = startIndex; i < endIndex; i++) {
        const isViewAllRow = this.hasViewAllRow && i === this.currentResults.length;
        const artist = isViewAllRow ? null : this.currentResults[i];
        if (!isViewAllRow && !artist) continue;

        const li = document.createElement('li');
        li.style.position = 'absolute';
        li.style.top = `${i * this.itemHeight}px`;
        li.style.left = '0';
        li.style.right = '0';
        li.style.height = `${this.itemHeight}px`;

        let a;
        if (isViewAllRow) {
          li.className = 'view-all-link';
          a = this.createViewAllLink();
        } else {
          a = document.createElement('a');
          a.href = artist.url;
          a.textContent = artist.name;
          if (artist.url?.includes('http')) {
            a.target = '_blank';
          }
        }
        li.appendChild(a);
        fragment.appendChild(li);
      }

      this.virtualContent.innerHTML = '';
      this.virtualContent.appendChild(fragment);
    }

    onMenuDrawerToggle() {
      if (this.menuDrawerDetails && !this.menuDrawerDetails.open) {
        if (this.submenu) this.submenu.classList.remove('is-open');
        if (this.searchInput) this.searchInput.value = '';
        this.mode = 'letter';
      }
    }

    onLetterClick(e) {
      e.preventDefault();
      e.stopPropagation();
      const letter = e.currentTarget.getAttribute('data-letter');
      this.showArtistsForLetter(letter);
    }

    onBackClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.submenu) {
        this.submenu.classList.remove('is-open');
      }
      if (this.searchInput) {
        this.searchInput.value = '';
      }
      this.mode = 'letter';
    }

    onSearchOpenClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.mode = 'search';
      this.currentLetter = null;

      if (this.submenuTitle) {
        this.submenuTitle.textContent = 'All Artists';
      }

      if (this.searchInput) {
        this.searchInput.value = '';
        this.searchInput.placeholder = 'Search all artists...';
      }

      // Open first so the list has a real height when the virtual window is measured
      if (this.submenu) {
        this.submenu.classList.add('is-open');
      }

      // Show all artists with virtual scroll
      this.renderVirtualList(this.fullArtists, true);

      if (this.submenu && this.searchInput) {
        setTimeout(() => this.searchInput.focus(), 100);
      }
    }

    onSearchInput(e) {
      const query = e.target.value.toLowerCase().trim();

      if (this.mode === 'search') {
        // Global search mode - use full artists list
        if (query.length < 2) {
          this.renderVirtualList(this.fullArtists, true);
          return;
        }
        const filtered = this.fullArtists.filter((artist) =>
          artist.name.toLowerCase().includes(query)
        );
        this.renderVirtualList(filtered, true);
      } else {
        // Letter filter mode - search full list when typing
        if (!query) {
          this.renderVirtualList(this.currentLetterArtists, false);
          return;
        }
        if (query.length < 2) {
          this.renderVirtualList(this.currentLetterArtists, false);
          return;
        }
        const filtered = this.fullArtists.filter((artist) =>
          artist.name.toLowerCase().includes(query)
        );
        this.renderVirtualList(filtered, true);
      }
    }

    createViewAllLink() {
      const a = document.createElement('a');
      a.href = `/pages/artists/#letter-${this.currentLetter}`;
      a.textContent = `View all ${
        this.currentLetter === 'other' ? '#' : this.currentLetter.toUpperCase()
      } artists...`;
      return a;
    }

    renderVirtualList(artists, isGlobalSearch) {
      if (!this.artistsList) return;

      // Reset state
      this.currentResults = artists;
      this.lastStartIndex = -1;
      this.lastEndIndex = -1;

      // In letter mode the list ends with a "view all" row, rendered by updateVisibleItems
      this.hasViewAllRow = !isGlobalSearch && !!this.currentLetter;

      if (artists.length === 0) {
        this.virtualContent = null;
        this.artistsList.innerHTML = '<li class="no-results">No artists found</li>';

        // A letter the curated list doesn't cover (Z today) would otherwise be a
        // dead end, even though the full list has artists under it.
        if (this.hasViewAllRow) {
          const li = document.createElement('li');
          li.className = 'view-all-link';
          li.appendChild(this.createViewAllLink());
          this.artistsList.appendChild(li);
        }
        return;
      }

      // Calculate total height
      const totalHeight = (artists.length + (this.hasViewAllRow ? 1 : 0)) * this.itemHeight;

      // Create virtual scroll container structure
      this.artistsList.innerHTML = `
        <div class="virtual-scroll-container" style="position: relative; height: ${totalHeight}px; min-height: 100%;">
          <div class="virtual-scroll-content"></div>
        </div>
      `;

      this.virtualContent = this.artistsList.querySelector('.virtual-scroll-content');

      // Reset scroll position
      this.artistsList.scrollTop = 0;

      // Initial render
      this.updateVisibleItems();
    }

    showArtistsForLetter(letter) {
      this.mode = 'letter';
      this.currentLetter = letter;
      const letters = 'abcdefghijklmnopqrstuvwxyz'.split('');
      this.currentLetterArtists = this.artists.filter((artist) => {
        if (letter === 'other') {
          return !letters.includes(artist.name[0].toLowerCase());
        }
        return artist.name[0].toLowerCase() === letter;
      });

      if (this.submenuTitle) {
        this.submenuTitle.textContent = letter === 'other' ? '# Artists' : `${letter.toUpperCase()} Artists`;
      }

      if (this.searchInput) {
        this.searchInput.value = '';
        this.searchInput.placeholder = 'Search all artists...';
      }

      // Open first so the list has a real height when the virtual window is measured
      if (this.submenu) {
        this.submenu.classList.add('is-open');
      }

      this.renderVirtualList(this.currentLetterArtists, false);
    }
  }

  customElements.define('mobile-artists-list', MobileArtistsList);
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // Use ResizeObserver for performant header height updates
      this.resizeObserver = new ResizeObserver(() => {
        this.setHeaderHeight();
      });
      this.resizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
